import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/index';
import App from './containers/App/App';
import './index.css';
import './styles/colors.css';

import { initializeAmplitudeUnified } from 'utils/amplitude';
import '@lambdatestincprivate/lt-components/lib/index.css';

import './styles/wcag_quick_start.css';

const container = document.getElementById('root');

initializeAmplitudeUnified();

if (container) {
  const root = createRoot(container);
  root.render(
    // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
    // </React.StrictMode>
  );
}
